module.exports = __webpack_public_path__ + "static/media/VV 5.ceef9a7b.mp3";